import { render } from "./BannerAutorization.vue?vue&type=template&id=27849907&scoped=true"
import script from "./BannerAutorization.vue?vue&type=script&lang=js"
export * from "./BannerAutorization.vue?vue&type=script&lang=js"

import "./BannerAutorization.vue?vue&type=style&index=0&id=27849907&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27849907"]])

export default __exports__